import { TableColumnType } from 'src/types/table';

export const allColumns: TableColumnType[] = [
    {
        label: 'id',
        key: 'ID',
        type: 'number',
    },
    {
        label: 'recipientName',
        key: 'RECIPIENT_NAME',
    },
    {
        label: 'contactPerson',
        key: 'CONTACT_PERSON',
    },
    {
        label: 'companyName',
        key: 'COMPANY_NAME',
    },
    {
        label: 'email',
        key: 'EMAIL',
    },
    {
        label: 'phone',
        key: 'PHONE',
    },
    {
        label: 'street',
        key: 'STREET',
    },
    {
        label: 'city',
        key: 'CITY',
    },
    {
        label: 'zipCode',
        key: 'ZIP_CODE',
    },
    {
        label: 'state',
        key: 'STATE',
    },
    {
        label: 'addressAdditionalInfo',
        key: 'ADDRESS_ADDITIONAL_INFO',
    },
    {
        label: 'provinceCode',
        key: 'PROVINCE_CODE',
    },
    {
        label: 'companyId',
        key: 'COMPANY_ID',
    },
    {
        label: 'GLN',
        key: 'GLN',
    },
];
